import { AccountTypes } from '@onevesthq/ov-enums';

export const LOCKED_IN_ACCOUNTS = [
  AccountTypes.LIRA,
  AccountTypes.LRSP,
  AccountTypes.RLSP,
];

export const INCOME_FUND_ACCOUNTS = [
  AccountTypes.RRIF,
  AccountTypes.RIF_SPOUSAL,
  AccountTypes.LIF,
  AccountTypes.PRIF,
  AccountTypes.LRIF,
  AccountTypes.RLIF,
];

export const ACCOUNTS_FOR_TRANSFER_TO_FHSA = [
  AccountTypes.PERSONAL,
  AccountTypes.RRSP,
  AccountTypes.FHSA,
];

export const ACCOUNTS_FOR_TRANSFER_FROM_FHSA = [
  AccountTypes.RRSP,
  AccountTypes.FHSA,
];

export const IRA_ACCOUNT_TYPES = [
  AccountTypes.USA_INH_IRA,
  AccountTypes.USA_INH_RT_IRA,
  AccountTypes.USA_IRA,
  AccountTypes.USA_RO_IRA,
  AccountTypes.USA_RT_IRA,
  AccountTypes.USA_SEP_IRA,
];
